import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Calendar, Users, MapPin, Target } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const NairobiPilot = () => {
 return (
 <div className="nairobi-pilot-page">
 <section className="page-hero">
 <div className="section-container">
 <h1 className="page-title">Nairobi Pilot</h1>
 <p className="page-subtitle">
 A small, intentional proof-of-concept launching September 2026.
 </p>
 </div>
 </section>

 <section className="pilot-intro-section">
 <div className="section-container">
 <p className="intro-text">
 Nova Roots begins with a micro school—a focused pilot designed to prove the model, refine 
 the approach, and demonstrate what's possible when education is built around how children 
 actually learn.
 </p>
 </div>
 </section>

 <section className="pilot-details-section">
 <div className="section-container">
 <h2 className="section-title">Year One Details</h2>
 <div className="details-grid">
 <Card className="detail-card">
 <CardContent className="detail-content">
 <div className="detail-icon">
 <Calendar size={28} />
 </div>
 <h3>Launch Date</h3>
 <p>September 2026</p>
 <p className="detail-note">
 Applications open throughout 2025. Early registration is encouraged.
 </p>
 </CardContent>
 </Card>

 <Card className="detail-card">
 <CardContent className="detail-content">
 <div className="detail-icon">
 <Users size={28} />
 </div>
 <h3>Enrolment</h3>
 <p>Limited places available</p>
 <p className="detail-note">
 Small cohorts ensure every child is known deeply and supported thoroughly.
 </p>
 </CardContent>
 </Card>

 <Card className="detail-card">
 <CardContent className="detail-content">
 <div className="detail-icon">
 <MapPin size={28} />
 </div>
 <h3>Location</h3>
 <p>Nairobi, Kenya</p>
 <p className="detail-note">
 Specific location details shared with interested families during the application process.
 </p>
 </CardContent>
 </Card>

 <Card className="detail-card">
 <CardContent className="detail-content">
 <div className="detail-icon">
 <Target size={28} />
 </div>
 <h3>Structure</h3>
 <p>Mixed-age learning pods</p>
 <p className="detail-note">
 Children grouped by readiness and development stage, not birthdate.
 </p>
 </CardContent>
 </Card>
 </div>
 </div>
 </section>

 <section className="why-pilot-section">
 <div className="section-container">
 <h2 className="section-title">Why Start Small?</h2>
 <div className="why-content">
 <Card className="why-card">
 <CardContent>
 <p>
 <strong>Depth over scale.</strong> Nova Roots prioritises quality, care, and precision. 
 Starting small allows us to test the model rigorously, learn from real experience, and 
 ensure every detail works before expanding.
 </p>
 </CardContent>
 </Card>
 <Card className="why-card">
 <CardContent>
 <p>
 <strong>Trust through proof.</strong> We're building something new. A micro school allows 
 us to demonstrate results, gather evidence, and earn trust through outcomes—not marketing.
 </p>
 </CardContent>
 </Card>
 <Card className="why-card">
 <CardContent>
 <p>
 <strong>Community building.</strong> The first cohort becomes the foundation of Nova Roots 
 culture. These families help shape what comes next.
 </p>
 </CardContent>
 </Card>
 </div>
 </div>
 </section>

 <section className="who-for-section">
 <div className="section-container">
 <h2 className="section-title">Who Is This For?</h2>
 <div className="who-content">
 <p className="who-intro">
 The Nairobi pilot is for families who:
 </p>
 <ul className="who-list">
 <li>Are values-led and high-expectation</li>
 <li>Are disillusioned with exam-heavy, comparison-driven schooling</li>
 <li>Care deeply about wellbeing, thinking, independence, and real-world readiness</li>
 <li>Are willing to be part of something new and contribute to its development</li>
 <li>Trust the model and are ready to commit fully</li>
 </ul>
 <p className="who-note">
 This is not for everyone. Nova Roots requires alignment, trust, and patience. Families who 
 are looking for quick fixes, familiar structures, or conventional outcomes should look elsewhere.
 </p>
 </div>
 </div>
 </section>

 <section className="next-steps-section">
 <div className="section-container">
 <div className="next-steps-box">
 <h2>Ready to Learn More?</h2>
 <p>
 If you're interested in the Nairobi pilot, the first step is to register your interest. 
 We'll share more details, answer questions, and discuss whether Nova Roots is the right 
 fit for your family.
 </p>
 <Link to="/contact">
 <Button className="cta-button">
 Register Interest <ArrowRight className="ml-2" size={18} />
 </Button>
 </Link>
 </div>
 </div>
 </section>
 </div>
 );
};

export default NairobiPilot;